import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Users, Crown, DollarSign, Flag, MessageCircle, UserX } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, PieChart, Pie, Cell } from "recharts";

const COLORS = ["#D4AF37", "#8B1E3F"];

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get("/admin/stats"); setS(data); } catch {} })(); }, []);
  if (!s) return <div className="font-head font-bold uppercase">Loading...</div>;

  const cards = [
    { label: "Total Users", value: s.total_users, icon: Users, c: "#D4AF37" },
    { label: "Premium", value: s.premium_users, icon: Crown, c: "#D4AF37" },
    { label: "Revenue", value: `$${s.total_revenue}`, icon: DollarSign, c: "#10B981", txt: "text-white" },
    { label: "Open Reports", value: s.open_reports, icon: Flag, c: "#8B1E3F", txt: "text-white" },
    { label: "Messages", value: s.total_messages, icon: MessageCircle, c: "#F3E8E6" },
    { label: "Suspended", value: s.suspended_users, icon: UserX, c: "#fff" },
  ];

  return (
    <div>
      <h1 className="font-head font-black text-4xl tracking-tighter mb-1">Admin Dashboard</h1>
      <p className="text-gray-600 font-medium mb-8">Platform analytics & revenue overview.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.label} className={`nb-border nb-shadow p-5 ${c.txt || ""}`} style={{ background: c.c }} data-testid={`admin-stat-${c.label.toLowerCase().replace(/ /g, "-")}`}>
            <c.icon className="w-6 h-6 mb-2" strokeWidth={2.5} />
            <div className="font-head font-black text-3xl">{c.value}</div>
            <div className="font-head font-bold uppercase text-xs tracking-wide">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white nb-border nb-shadow p-6">
          <h3 className="font-head font-black text-xl mb-4">Revenue by Month</h3>
          {s.revenue_series.length === 0 ? <p className="text-gray-500 font-medium py-10 text-center">No revenue data yet.</p> : (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={s.revenue_series}>
                <XAxis dataKey="month" tick={{ fontFamily: "DM Sans", fontSize: 12 }} />
                <YAxis tick={{ fontFamily: "DM Sans", fontSize: 12 }} />
                <Tooltip contentStyle={{ border: "2px solid #0A0A0A", borderRadius: 0 }} />
                <Bar dataKey="revenue" fill="#8B1E3F" stroke="#0A0A0A" strokeWidth={2} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
        <div className="bg-white nb-border nb-shadow p-6">
          <h3 className="font-head font-black text-xl mb-4">Membership Split</h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={s.membership_distribution} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} stroke="#0A0A0A" strokeWidth={2} label>
                {s.membership_distribution.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ border: "2px solid #0A0A0A", borderRadius: 0 }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
